import Modals from './modules/modal';
import Includes from './modules/include';
import AnchorLink from './modules/anchorlink';
import HashUrl from './modules/hash_url';
import Accordions from './modules/accordion';
import Swiper from 'swiper/bundle';
// import './modules/intersection-observer';
// import './modules/carousel';

// PCSP判定
window.device = '';
function deviceJudgement(){
  let windowWidth = window.outerWidth;
  let viewportTag =  document.querySelector('[name="viewport"]');
  if (windowWidth < 600) {
    window.device = 'sp';
    viewportTag.setAttribute('content', 'width=device-width, interactive-widget=overlays-content');
  }else if ( windowWidth >= 600 && windowWidth <= 1080) {
    window.device = 'pc';
    viewportTag.setAttribute('content', 'width=1080, initial-scale=1, interactive-widget=overlays-content');
  }else{
    window.device = 'pc';
    viewportTag.setAttribute('content', 'width=device-width, initial-scale=1, interactive-widget=overlays-content');
  }
}
deviceJudgement();
window.addEventListener('resize',function(){
  deviceJudgement();
});


document.addEventListener('DOMContentLoaded',function(){

  //html include
  const includeContainers = Array.from(document.querySelectorAll('[data-inc]'));
  includeContainers.forEach((container) => {
    new Includes(container);
  });

  window.addEventListener('load',function(){

    //html include in include
    const includeInIncludeContainers = Array.from(document.querySelectorAll('[data-inc]'));
    includeInIncludeContainers.forEach((container) => {
      if(!container.hasChildNodes()){
        new Includes(container);
      }
    });

    //smooth anchor
    // 上部固定要素があれば指定する
    const fixedContent = document.querySelector('[data-inc="/dp/shared/inc/header.html"]');
    //ページ内リンク
    let anchorLinks = Array.from(document.querySelectorAll('a'));
    anchorLinks.forEach((link) => {
      new AnchorLink(link,fixedContent);
    });
    //ハッシュ付きURLでアクセス
    new HashUrl(fixedContent);

    //Header Menu
    const menuBtns = Array.from(document.querySelectorAll('.js-menu-btn'));
    const menuPanel = document.getElementById('dp_header');
    let menuCover = document.createElement('div');
    menuCover.classList.add('globalnav-cover');
    document.querySelector('body').appendChild(menuCover);
    menuBtns.forEach((menuBtn) => {
      menuBtn.addEventListener('click', function(evt){
        evt.preventDefault();
        menuPanel.classList.toggle('m-opened');
        menuCover.classList.toggle('m-opened');
      });
    });
    menuCover.addEventListener('click', function(){
      menuPanel.classList.toggle('m-opened');
      menuCover.classList.toggle('m-opened');
    })

    // ぱんくずが見えなくなったらヘッダを小さく
    // const breadcrumb = document.querySelector('.breadcrumb');
    const ioTarget = document.createElement('div');
    ioTarget.id = 'ioTarget';
    // ioTarget.prependChild(document.querySelector('body'));
    document.querySelector('body').appendChild(ioTarget);
    const effectTarget = document.getElementById('dp_header');
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        // ioTargetが見えている
        effectTarget.classList.add('m-big');
      }else{
        // ioTargetが見えていない
        effectTarget.classList.remove('m-big');
      }
    });
    if(ioTarget){
      observer.observe(ioTarget);
    }

    // headerの高さをCSS変数に格納（PC用）
    setHeaderH();
    window.addEventListener('resize rotate',function(){
      setHeaderH();
    });
    function setHeaderH(){
      let dpHeader = document.querySelector('#dp_header');
      document.documentElement.style.setProperty( '--header-h', dpHeader.clientHeight + 'px');
    }

    //Accordion
    const accBtns = Array.from(document.querySelectorAll('.js-acc-btn'));
    accBtns.forEach((accordionBtn) => {
      new Accordions(accordionBtn);
    });

    //Modal window
    const modalBtns = Array.from(document.querySelectorAll('.js-modal-open'));
    modalBtns.forEach((modalBtn) => {
      new Modals(modalBtn);
    });

    // shop modal campaign
    const shopModalOpenBtns = Array.from(document.querySelectorAll('[data-modal="modalShop"]'));
    shopModalOpenBtns.forEach((btn) => {
      btn.addEventListener('click', function(){
        // setTimeout(() => {
          const swiperModalCampaign = new Swiper(".js-swiper-modal-campaign", {
            grabCursor: true,
            pauseOnMouseEnter: true,
            breakpoints: {
              0: {
                slidesPerView: 1
              },
              600: {
                slidesPerView: 3,
                spaceBetween: 15,
                slidesPerGroup: 3,
                navigation: {
                  nextEl: ".modal-linkbox-campaign-next",
                  prevEl: ".modal-linkbox-campaign-prev"
                }
              }
            },
            pagination: {
              el: ".modal-linkbox-campaign-pagination",
              clickable: true,
            },
          });
        // },2000);
      });
    });

    
    // -----------------------------------
    // lpの下にいれるショップエリア内キャンペーンが
    // インクルードされたタイミングでSwiperを動かす
    // -----------------------------------
    const targetNode = document.getElementById('lp-shop-campaign');
    const config = { childList: true, subtree: true };
    const callback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // 読み込み完了後にSwiperを初期化
          const swiperLpShopCampaign = new Swiper(".js-swiper-lp-shop-campaign", {
            grabCursor: true,
            pauseOnMouseEnter: true,
            breakpoints: {
              0: {
                slidesPerView: 1
              },
              600: {
                slidesPerView: 3,
                spaceBetween: 15,
                slidesPerGroup: 3,
                navigation: {
                  nextEl: ".lp-shop-linkbox-campaign-next",
                  prevEl: ".lp-shop-linkbox-campaign-prev"
                }
              }
            },
            pagination: {
              el: ".lp-shop-linkbox-campaign-pagination",
              clickable: true,
            },
          });
          // 監視を停止
          observer.disconnect();
          break;
        }
      }
    };
    
    const myObserver = new MutationObserver(callback);
    myObserver.observe(targetNode, config);

  });
});



